import { X } from 'lucide-react';

const SidebarHeader = ({ showCloseButton = false, onClose }) => (
  <div
    className={`flex h-16 flex-shrink-0 items-center border-b border-gray-200 px-4 ${
      showCloseButton ? 'justify-between' : 'justify-center'
    }`}
  >
    <div className={`flex items-center ${showCloseButton ? 'flex-1 justify-center' : ''}`} style={{ gap: '16px' }}>
      <img src="/assets/logo.png" alt="Clickorico" className="h-10 w-auto object-contain" />
      <span className="text-base font-bold text-brand-gradient">
        Admin
      </span>
    </div>
    {showCloseButton && (
      <button
        type="button"
        onClick={onClose}
        className="text-gray-400 hover:text-gray-600"
        aria-label="Fermer le menu"
      >
        <X className="h-6 w-6" />
      </button>
    )}
  </div>
);

export default SidebarHeader;
